
import { DateTime } from 'luxon';

export default class DateFormat {

	static getDataAtual() {
		return DateTime.now().toFormat('yyyy/LL/dd');
	}

	static getDataAnterior(dias) {
		return DateTime.now().minus({ days: dias }).toFormat('yyyy/LL/dd');
	}

	static getDataHoraAtual() {
		return DateTime.now().toFormat('yyyy/LL/dd HH:mm');
	}

	static getDataInicioMesAtual() {
		return `${DateTime.now().toFormat('yyyy/LL')}/01`;
	}

	static getTimestampParaData(timestamp) {
		return !timestamp ? null : DateTime.fromMillis(timestamp).toFormat('yyyy/LL/dd');
	}

	static getTimestampParaDataHora(timestamp) {
		return !timestamp ? null : DateTime.fromMillis(timestamp).toFormat('yyyy/LL/dd HH:mm');
	}

	static formatarDataSqlParaTela(data) {
		return !data ? null : (DateTime.fromISO(data).isValid ? DateTime.fromISO(data) : DateTime.fromFormat(data, 'yyyy/LL/dd')).toFormat('dd/LL/yyyy');
	}

	static formatarDataHoraSqlParaTela(dataHora) {
		return !dataHora ? null : (DateTime.fromISO(dataHora).isValid ? DateTime.fromISO(dataHora) : DateTime.fromFormat(dataHora, 'yyyy/LL/dd HH:mm')).toFormat('dd/LL/yyyy HH:mm');
	}

	static formatarDataHoraPickerParaBanco(dataHora) {

		if (!dataHora) return null;

		let dt = DateTime.fromISO(dataHora);

		if (!dt.isValid) {
			dt = DateTime.fromSQL(dataHora);
		}

		if (!dt.isValid) {
			dt = DateTime.fromFormat(dataHora, 'yyyy/LL/dd HH:mm');
		}

		if (!dt.isValid) {
			dt = DateTime.fromFormat(dataHora, 'yyyy-LL-dd HH:mm');
		}

		return dt.isValid
			? dt.toFormat('yyyy/LL/dd HH:mm')
			: null;
	}

	static formatarDataHoraSqlParaTelaDescritivo(dataHora) {
		let dataHoraFormatada = !dataHora ? null : (DateTime.fromISO(dataHora).isValid ? DateTime.fromISO(dataHora) : DateTime.fromFormat(dataHora, 'yyyy/LL/dd HH:mm')).toFormat('dd/LL/yyyy HH:mm');

		if (dataHoraFormatada) {
			const data = dataHoraFormatada.split(' ')[0];
			const hora = dataHoraFormatada.split(' ')[1];

			if (DateFormat.formatarDataSqlParaTela(DateFormat.getDataAtual()) == data) {
				return `Hoje ${hora}`
			} else if (DateFormat.formatarDataSqlParaTela(DateFormat.getDataAnterior(1)) == data) {
				return `Ontem ${hora}`
			} else {
				return `${data} ${hora}`
			}
		} else {
			return null;
		}
	}

	static formatarDataTelaParaSql(data) {
		return !data ? null : DateTime.fromFormat(data, 'dd/LL/yyyy').toFormat('yyyy/LL/dd');
	}

	static formatarDataHoraTelaParaSql(dataHora) {
		return !dataHora ? null : DateTime.fromFormat(dataHora, 'dd/LL/yyyy HH:mm').toFormat('yyyy/LL/dd HH:mm');
	}

	static formatarDataTelaParaParametro(data) {
		return !data ? null : (DateTime.fromISO(data).isValid ? DateTime.fromISO(data) : DateTime.fromFormat(data, 'dd/LL/yyyy')).toFormat('yyyy-LL-dd');
	}

}
